import Vue from "vue";
import Router from "vue-router";
import TestpaperList from "@/page/TestpaperList";
import DoTopic from "@/page/DoTopic";
import LookTopic from "@/page/LookTopic";
import Login from "@/page/Login";
import Analysis from "@/page/Analysis";
import CourseList from "@/page/CourseList";
import CourseDescription from "@/page/CourseDescription";
import SubmitOrder from "@/page/SubmitOrder";
import Pay from "@/page/Pay";
import AccountPaid from "@/page/AccountPaid";
// import payGateWay from '@/page/payGateWay'
import Scan from "@/components/Scan";
import Demand from "@/page/Demand";
import Live from "@/page/live";
// import Index from '@/page/Index'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    // {
    //   path: '/',
    //   name: 'index',
    //   component: Index
    // },
    {
      path: "/",
      name: "index",
      component: () => import("@/page/Index")
      // meta:{title: '翰墨教师证--品质决定高度，实力成就未来'},
    },
    {
      path: "/me",
      name: "Me",
      component: () => import("@/page/Profile"),
      // meta:{title: '个人中心--翰墨教师证--品质决定高度，实力成就未来'},
      children: [
        {
          path: "courses",
          component: () => import("@/components/me/MyCourses")
        },
        { path: "order", component: () => import("@/components/me/MyOrder") },
        {
          path: "setting",
          component: () => import("@/components/me/MySetting")
        },
        {
          path: "address",
          component: () => import("@/components/me/MyAddress")
        },
        {
          path: "history",
          component: () => import("@/components/me/MyHistory")
        },
      ]
    },
    {
      path: "/testpaperList",
      name: "TestpaperList",
      // meta:{title: '试卷列表--翰墨教师证--品质决定高度，实力成就未来'},
      component: TestpaperList
    }, //试卷列表
    {
      path: "/doTopic",
      name: "dotopic",
      component: DoTopic
    },
    {
      path: "/lookTopic",
      name: "looktopic",
      component: LookTopic
    },  // 城市选择
    {
      path: "/citySelect",
      name: "citySelect",
      component: () => import("@/page/citySelect.vue")
    }, //做题页
    {
      path: "/login",
      name: "login",
      component: Login
    }, //登陆页
    {
      path: "/grade",
      name: "grade",
      component: () => import("@/page/Grade"),
      meta: {
        fullPage: true
      }
    },//评分
    {
      path: "/analysis",
      name: "analysis",
      component: Analysis
    }, //解析
    {
      path: "/courseList",
      name: "courselist",
      component: CourseList
    }, //课程列表
    {
      path: "/courseDescription/:course_id",
      name: "courseDescription",
      component: CourseDescription
    }, //课程详情
    {
      path: "/submitOrder/:course_id",
      name: "submitOrder",
      component: SubmitOrder
    }, //创建订单
    {
      path: "/pay",
      name: "pay",
      component: Pay
    }, //支付
    {
      path: "/accountPaid",
      name: "accountPaid",
      component: AccountPaid
    }, //完成订单
    // {
    //   path: '/payGateWay',
    //   name: 'payGateWay',
    //   component: payGateWay
    // },
    {
      path: "/scan",
      name: "scan",
      component: Scan
    },
    {
      path: "/demand",
      name: "demand",
      component: Demand,
      meta: {
        fullPage: true,
        // keepAlive: true,
      }
    }, //点播
    {
      path: "/live",
      name: "live",
      component: Live,
      meta: {
        fullPage: true
      }
    } //直播
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js